// extracted by mini-css-extract-plugin
module.exports = {"header":"TheHeader_header_5c_tm","isFixed":"TheHeader_isFixed_3ikip","slideIn":"TheHeader_slideIn_2G4Ro"};